import type { ReactNode } from 'react';

import { cn } from '../../lib/cn.ts';

const tones = {
  neutral: 'bg-muted text-muted-foreground',
  success: 'bg-success/15 text-foreground',
  warning: 'bg-warning/20 text-foreground',
  danger: 'bg-danger/15 text-foreground',
  info: 'bg-soft text-soft-foreground',
} as const;

export function Badge({
  tone = 'neutral',
  children,
}: {
  tone?: keyof typeof tones;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        tones[tone],
      )}
    >
      {children}
    </span>
  );
}
